import React, { useState } from 'react';

interface VerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onVerify: (code: string) => Promise<void>;
  title?: string;
  message?: string;
}

const VerificationModal: React.FC<VerificationModalProps> = ({
  isOpen,
  onClose,
  onVerify,
  title = 'Bestätigung erforderlich',
  message = 'Bitte gib den 6-stelligen Code aus deiner E-Mail ein.'
}) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onVerify(code);
      setCode('');
      onClose();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Code-Verifizierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
      }}>
        <h2 style={{ marginTop: 0, color: '#333' }}>{title}</h2>
        <p style={{ color: '#666', marginBottom: '20px' }}>{message}</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Bestätigungscode</label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="123456"
              maxLength={6}
              required
              autoFocus
              disabled={loading}
              style={{
                fontSize: '24px',
                letterSpacing: '8px',
                textAlign: 'center',
                fontFamily: 'monospace'
              }}
            />
          </div>

          {error && <div className="error">{error}</div>}

          <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setCode('');
                setError('');
                onClose();
              }}
              disabled={loading}
              style={{ flex: 1 }}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || code.length !== 6}
              style={{ flex: 1 }}
            >
              {loading ? 'Prüfe...' : 'Bestätigen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerificationModal;
